/* oxlint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import {QLayout,QHeader,QFooter,QPageContainer,QToolbar,QPage,QSpinnerDots,QBtn,QBtnDropdown,QSelect,QInput,QToggle,QCard,QCardSection,QDrawer,QList,QItem,QItemSection,QItemLabel,QSeparator,QBadge,QIcon,QTooltip,Notify,Dialog,BottomSheet} from 'quasar'

export default { config: {"dark":"auto"},components: {QLayout,QHeader,QFooter,QPageContainer,QToolbar,QPage,QSpinnerDots,QBtn,QBtnDropdown,QSelect,QInput,QToggle,QCard,QCardSection,QDrawer,QList,QItem,QItemSection,QItemLabel,QSeparator,QBadge,QIcon,QTooltip},plugins: {Notify,Dialog,BottomSheet} }
